<footer class="calendar_footer">
  <span class="calendar_footer__info">
    {{ __('calendar.description') }}
  </span>
  <span class="calendar_footer__close" role="close_calendar">
    {{ __('calendar.close') }}
  </span>
</footer>
